export function getPriceUnitLabel(priceType) {
  switch (String(priceType)) {
    case '1':
      return '万字'
    case '2':
      return '篇'
    default:
      return '千字'
  }
}

export function getPriceUnitSuffix(priceType) {
  return `/${getPriceUnitLabel(priceType)}`
}

export function isPublishDateRequired(category) {
  const id = String(category && category.id ? category.id : '')
  const cid = String(category && category.cid ? category.cid : '')

  return ['6', '15'].includes(id) || ['6', '15'].includes(cid)
}

export function getCheckDbsConfig(category) {
  const id = String(category && category.id ? category.id : '')
  const cid = String(category && category.cid ? category.cid : '')
  const name = category && category.name ? category.name : ''

  const map = {
    '2': { label: '检测大学生论文联合比对库', value: 'ug', checked: true },
    '3': { label: '检测硕博论文联合比对库', value: 'grad', checked: true },
    '4': { label: '检测大学生论文联合比对库', value: 'ug', checked: false },
    '12': { label: '检测大学生论文联合比对库', value: 'ug', checked: true },
    '13': { label: '检测硕博论文联合比对库', value: 'grad', checked: true },
    '20': { label: '检测大学生论文联合比对库', value: 'ug', checked: false }
  }

  if (map[id]) {
    return map[id]
  }

  if (map[cid]) {
    return map[cid]
  }

  if (name.indexOf('硕博') !== -1) {
    return { label: '检测硕博论文联合比对库', value: 'grad', checked: true }
  }

  if (name.indexOf('本科') !== -1) {
    return { label: '检测大学生论文联合比对库', value: 'ug', checked: true }
  }

  if (name.indexOf('高职') !== -1 || name.indexOf('高专') !== -1) {
    return { label: '检测大学生论文联合比对库', value: 'ug', checked: false }
  }

  return null
}

export function getCategoryPrice(category, userGroup) {
  const basePrice = parseFloat(category.price || 0) || 0
  let currentPrice = basePrice

  switch (Number(userGroup || 0)) {
    case 3:
      currentPrice = parseFloat(category.vip_price || 0) || basePrice
      break
    case 2:
      currentPrice = parseFloat(category.agent_price2 || 0) || basePrice
      break
    case 1:
      currentPrice = parseFloat(category.agent_price1 || 0) || basePrice
      break
    default:
      currentPrice = basePrice
  }

  let teamQualified = false
  try {
    const value = window.sessionStorage.getItem('team_discount_qualified')
    teamQualified = value === '1'
  } catch (error) {
    teamQualified = false
  }

  if (!teamQualified) {
    return currentPrice
  }

  const teamPrice = category.vip_price
    ? parseFloat(category.vip_price || 0) || currentPrice
    : parseFloat((basePrice * 0.9).toFixed(2))

  return Math.min(currentPrice, teamPrice)
}

export function normalizeGroupedCategories(payload) {
  return payload && typeof payload === 'object' ? payload : {}
}

export function getGroupedCategories(payload, groupIds = []) {
  const grouped = normalizeGroupedCategories(payload)

  return groupIds.reduce((list, groupId) => {
    const group = grouped[groupId]
    if (Array.isArray(group)) {
      return list.concat(group)
    }

    return list
  }, [])
}

export function getCheckCategories(payload) {
  return getGroupedCategories(payload, [1, 4])
}

export function getAigcCategories(payload) {
  return getGroupedCategories(payload, [2, 6])
}

export function getAllCategories(payload) {
  return getCheckCategories(payload).concat(getAigcCategories(payload))
}

export function formatVersionName(category, withClassname = false) {
  if (!category) {
    return ''
  }

  const classname = category.classname || ''
  const name = category.name || ''

  if (withClassname && classname && name) {
    return `【${classname}】- ${name}`
  }

  return name
}

export function getChargeCount(words, priceType) {
  const count = Number(words || 0)

  if (String(priceType) === '2') {
    return 1
  }

  if (String(priceType) === '1') {
    return Math.max(Math.ceil(count / 10000), 1)
  }

  return Math.max(Math.ceil(count / 1000), 1)
}

export function computeUnitPrice(totalPrice, words, priceType) {
  const total = parseFloat(totalPrice)
  const chargeCount = getChargeCount(words, priceType)

  if (Number.isNaN(total) || !chargeCount) {
    return ''
  }

  return total / chargeCount
}

export function formatMoney(value) {
  const amount = parseFloat(value)

  if (Number.isNaN(amount)) {
    return ''
  }

  return amount.toFixed(2)
}
